var mamagogo = (function($){
	var pub = {

		spinner: '<i class="fa fa-circle-o-notch fa-spin"></i>',
		closeIcon: '<i class="fa fa-close"></i>',
		errorMessage: 'Произошла ошибка',
		alertMessageCloseInterval: 5000,


		showRow: function()
		{
			$('.show-row-btn').on('click', function(){
				var self = $(this),
					selfRow = self.closest('.show-row-btn-row'),
					closestParent = self.closest('.show-row'),
					hiddenBlock = closestParent.find('.hidden-row');


				hiddenBlock.removeClass('hidden');
				selfRow.addClass('hidden');

			});
		},


		addSocial: function()
		{
			$(".add-social").click(function(e){
				$(this).parents().find('.social-box').slideDown();
				e.stopPropagation();
			});
			$(window).click(function(){
				$('.social-box').slideUp();
			});

			$('.social-box span').on('click', function(e){
				e.preventDefault();
				var self = $(this),
					parentLi = self.closest('li'),
					site = self.data('site'),
					formRow = $('.social-'+site);

				parentLi.remove();
				formRow.removeClass('hidden');
			})
		},


		socialInputChange: function()
		{
			/*var suffixInput = {
				'freelance':'http://free-lance.ru/users/',
				'linkedin':'http://linkedin.com/',
				'facebook':'http://facebook.com/'
			};

			$('.social-input input').on('input', function(e){
				var self = $(this),
					site = self.data('site'),
					currentVal = self.val(),
					suffix = (suffixInput[site] != undefined) ? suffixInput[site] : 'http://',
					index = currentVal.indexOf(suffix);

				if(index == -1 || index > 0) {
					self.val(suffix);
				}

			});*/
		},

		preferredContact: function()
		{
			$('.preferred_contact_wrap').each(function(){
				var wrap = $(this);

				var phoneInputs = wrap.find('.preferred_contact');
				var rowValidated = [];
				phoneInputs.each(function(index){
					var input = $(this),
						rowRadio = wrap.find('input[type="radio"]');

					input.on('input', function(i){
						var val = $(this).val();
						var match = val.match(/[^0-9]/g);

						if(val !== '') {
							rowValidated[index] = match == null;
						}else {
							rowValidated[index] = false;
						}

						var isNotValidated = _.contains(rowValidated,false);

						if(rowValidated.length > 2 && !isNotValidated) {
							rowRadio.removeAttr('disabled');
						} else {
							rowRadio.attr('disabled','disabled');
							if(rowValidated.length >2 && rowRadio.is(':checked')  ) {
								$('.preferred_contact_default').click();
							}
						}
					});

				})

			});

			$('.preferred_contact').trigger('input');
		},


		uploadPhoto: function()
		{
			$.ajaxSetup({
				headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() }
			});
			$('#btn-uploadImage').on('click', function (e) {
				e.preventDefault();

				var uploadBtn = $(this),
					uploadBtnText = uploadBtn.text();

				var folioImg = $('#image');

				var imgData = folioImg.prop('files')[0];
				var formData = new FormData();
				var userPhotoTemplate = $('#userPhotoTemplate').html();

				formData.append('image', imgData);

				$.ajax({
					type: "POST",
					data: formData,
					url: $('#uploadImage').attr('action'), //FormUrl
					cache: false,
					contentType: false,
					processData: false,
					beforeSend: showRequest,
					success: showResponse,
					dataType: 'json'
				});
				function showRequest(formData, jqForm, options) {
					$('.imageInput').html("");
					uploadBtn.attr('disabled', 'disabled');
					uploadBtn.html(uploadBtnText + " " + pub.spinner);
					return true;
				}

				function showResponse(response, statusText, xhr, $form) {
					if (response.success == false) {
						var arr = response.errors;
						$('.imageInput').html('<div class="help-block">'+arr['image'][0]+'</div>');

					} else {
						var htmlToAppend = _.template(userPhotoTemplate, response.image);
						$('.empty-user-photo').before(htmlToAppend);
						$('.empty-user-photo').removeClass("hidden");
					}
					folioImg.val("").trigger('change');
					uploadBtn.removeAttr('disabled');
					uploadBtn.html(uploadBtnText);
				}

			});

			$(document).on('click','.deleteImg', function(e){
				e.preventDefault();
				var self = $(this),
					href = self.attr('href');

				$.get(href, function(data){
					if(data.success) {
						self.closest('.user-photo').remove();
					}
				});

			})
		},

		/*START Edit Personal*/

		relocationRadio: function()
		{
			var relocationInput = $('.relocation');

			relocationInput.on('change', function(){
				var self = $(this),
					relocationHidden = $('.relocationHidden'),
					relocationCheckedVal = $('.relocation:checked').val();

				if( relocationCheckedVal == 'no_relocation' || relocationCheckedVal == '') {
					relocationHidden.addClass('hidden');
					relocationHidden.find('select').val("").trigger('change');
				} else {
					relocationHidden.removeClass('hidden');
				}
			});

			relocationInput.trigger('change');
		},

		citizenRadio: function()
		{
			var citizenInput = $('.applicantCitizen');

			citizenInput.on('change', function(){
				var self = $(this),
					val = self.val(),
					citizenHidden = $('.citizenHidden'),
					citizenNull = $('.citizenNull'),
					isHelperChecked = $('.citizenHelper:checked').length,
					citizenSelect = $('.citizenSelect2');

				if(isHelperChecked) {
					citizenHidden.addClass('hidden');
					citizenSelect.val('');
				} else {
					citizenNull.attr("checked", 'checked');
					citizenHidden.removeClass('hidden');
				}
				$('.citizenSelectedText').html('');
			});


			citizenInput.trigger('change');


			var citizenSelect = $('.citizenSelect2');
			function e(e, t, n, r) {
				return e % 10 < 5 && e % 10 > 0 && e % 100 < 5 || e % 100 > 20 ? e % 10 > 1 ? n : t : r
			}
			citizenSelect.select2({
				maximumSelectionLength: 3,
				language: {
					errorLoading: function () {
						return "Невозможно загрузить результаты"
					}, inputTooLong: function (t) {
						var n = t.input.length - t.maximum, r = "Пожалуйста, введите на " + n + " символ";
						return r += e(n, "", "a", "ов"), r += " меньше", r
					}, inputTooShort: function (t) {
						var n = t.minimum - t.input.length, r = "Пожалуйста, введите еще хотя бы " + n + " символ";
						return r += e(n, "", "a", "ов"), r
					}, loadingMore: function () {
						return "Загрузка данных…"
					}, maximumSelected: function (t) {
						var n = "Ты можешь выбрать не более трех элементов";
						return n;
					}, noResults: function () {
						return "Совпадений не найдено"
					}, searching: function () {
						return "Поиск…"
					}
				}
			});
			citizenSelect.on('change', function(){
				var thisVal = $(this).val();
				var text = '';
				if(thisVal != null) {
					$.each(thisVal, function(i,v){
						var getText  = $('option[value="'+v+'"]').text();
						text += getText;

						if(thisVal != undefined && thisVal.length != (i+1)) {
							if(thisVal.length == 1)
								text += ' ';
							else
								text += ', ';
						}

					});
				}


				$('.citizenSelectedText').html(text);
			});
			citizenSelect.trigger('change');
		},

		selectTool: function()
		{
			$('.selectTool').on('click', function(e){
				e.preventDefault();

				var self = $(this),
					select = $('#' + self.data('id')),
					toolVal = parseInt(self.data('value')),
					isMultiple = select.attr('multiple') != undefined,
					selectVal = select.val();

				if(isMultiple && selectVal != null){
					var multipleVal = _.union(selectVal,toolVal+'');
					select.val(multipleVal).trigger('change');
				}else {
					select.val(toolVal).trigger('change');
				}
			});
		},

		/*END Edit Personal*/


		/*START RESUME POSITION*/
		maxCheckedLength: 3,

		autocompletePositionTitle: function()
		{
			var $input = $('#positionTitle');
			if($input.length) {
				$input.typeahead({
					ajax: {
						url: '/ajax/position',
						triggerLength: 1
					},
					displayField:'name',
					onSelect: function(position){
						var positionId = position.value;
						$.ajax({
							url: '/ajax/position-prof-area',
							data: {positionId:positionId},
							success: function(data){
								pub.$lastClicked = $('.treeSelectModalOpen');
								$.each(data.child,function(i,v){
									$('.treeSelectInput input[value="' + v.id + '"]').prop('checked', true);
								});

								$('.treeSelectInput input[value="' + data.id + '"]').prop('checked', true).trigger('change');

								$('#treeSelectModal .ok').trigger('click');
							}
						})
					}
				});
			}
		},

		onCareerChange: function()
		{
			$('input[name="career"]').on('change', function(){

				if($(this).is(':checked')) {
					$('.professionalArea').addClass('hidden');
					$('.specializationArea').removeClass('hidden');
				}else {
					$('.professionalArea').removeClass('hidden');
					$('.specializationArea').addClass('hidden');
				}
			});
			$('input[name="career"]').trigger('change');
		},

		onChangeSpecializationArea: function()
		{
			$('.specializationArea input[type="checkbox"]').on('change', function(){
				var sCheckboxes = $('.specializationArea input[type="checkbox"]');
				var sChecked = $('.specializationArea input[type="checkbox"]:checked'),
					sCheckedLength = sChecked.length;
				if(sCheckedLength >= pub.maxCheckedLength) {
					$('.specializationArea input[type="checkbox"]:not(:checked)').attr('disabled',true);
				}else {
					sCheckboxes.removeAttr('disabled');
				}
			});

		},



		profAreaSelect: function()
		{
			var profAreaInput = $('.profAreaInput');
			profAreaInput.find('.profArea-parent-title').on('click', function(){
				var self = $(this),
					closesLi = self.closest('li'),
					childUl = closesLi.find('.profArea-child-ul');

					childUl.toggleClass('hidden');
					closesLi.find('.profArea-parent-icon .fa').toggleClass('fa-minus fa-plus')
			});


			var profAreaCheckboxes = profAreaInput.find('input[type="checkbox"]');


			profAreaCheckboxes.on('change', function(){
				var self = $(this),
					parent = self.closest('.profArea-parent-li');

					var notActiveCheckboxes = $('.profArea-parent-li').not(parent).find('input[type="checkbox"]');
					var parentCheckboxLength = parent.find('input[type="checkbox"]:checked').not('.hiddenParentCheckbox').length;
					if(parentCheckboxLength) {
						parent.find('.hiddenParentCheckbox').attr('checked','checked');
					}else {
						$('.hiddenParentCheckbox').removeAttr('checked','checked');
					}

					if(profAreaCheckboxes.is(':checked')) {
						notActiveCheckboxes.attr('disabled','disabled');
					} else {
						profAreaCheckboxes.removeAttr('disabled');
						profAreaCheckboxes.parent()
					}


					var checkedLength= profAreaInput.find('input[type="checkbox"]:checked').not('.hiddenParentCheckbox').length;
					if(checkedLength >= pub.maxCheckedLength) {
						profAreaInput.find('input[type="checkbox"]').not(':checked').attr('disabled','disabled');
					} else {
						parent.find('input[type="checkbox"]').removeAttr('disabled');
					}


			});
		},

		treeSelectInput: function()
		{
			var treeSelect = $('.treeSelectInput'),
				selectMax = treeSelect.data('select-max'),
				selectAll = Boolean(parseInt(treeSelect.data('select-all')));

			treeSelect.find('.treeSelect-parent-title').on('click', function () {
				var self = $(this),
					closesLi = self.closest('li'),
					childUl = closesLi.find('.treeSelect-child-ul');

				childUl.toggleClass('hidden');
				closesLi.find('.treeSelect-parent-icon .fa').toggleClass('fa-minus fa-plus')
			});


			var treeSelectCheckboxes = treeSelect.find('input[type="checkbox"]');


			treeSelectCheckboxes.on('change', function () {
					var self = $(this),
						checkedInputs = $('.treeSelectInput input:checked').not('.hiddenParentCheckbox'),
						isCheckedParentLi = checkedInputs.closest('.treeSelect-parent-li');

				// Выставляем чекед для родителя если хотябы один дочерный чекбокс ис чекед
				treeSelect.find('.treeSelect-parent-li').each(function(){
					var checkedInParentLi = $(this).find('.treeSelect-child-li input[type="checkbox"]:checked'),
						hiddenCheckbox = $(this).find('.hiddenParentCheckbox');

					if(checkedInParentLi.length) {
						hiddenCheckbox.prop('checked',true);
					} else{
						hiddenCheckbox.prop('checked',false);
					}

				});

				if(selectAll == false && checkedInputs.length >= 1) {
					var notParentLi = treeSelect.find('.treeSelect-parent-li').not(isCheckedParentLi),
						notParentLiCheckbox = notParentLi.find('input[type="checkbox"]');
					notParentLiCheckbox.removeAttr('checked').attr('disabled','disabled');

				}else if(selectAll == false && checkedInputs.length == 0) {
					treeSelectCheckboxes.removeAttr('disabled');
				}


				if (checkedInputs.length >= selectMax) {
					treeSelect.find('input[type="checkbox"]').not(':checked').prop('disabled', true);
				} else {
					if(selectAll) {
						treeSelectCheckboxes.removeAttr('disabled');
					} else {
						isCheckedParentLi.find('input[type="checkbox"]').not('.hiddenParentCheckbox').removeAttr('disabled');
					}
				}
			});
		},


		$lastClicked:null,
		treeSelectSearch: function()
		{
			var searchFilterInput = $('#searchFilterTreeSelect input');
			searchFilterInput.on('input', function (e) {

				var search = $(this).val().toLowerCase(),
					searchWhere = $(this).data('list'),
					$searchWhere = $(searchWhere);


				var elementWrap = $searchWhere.find('.treeSelect-child-li label');
				elementWrap.each(function () {
					var textWrap = $(this).find('.treeSelect-name');

					var name = textWrap.text().trim();
					if (name.toLowerCase().indexOf(search) !== -1) {
						$(this).parent().removeClass('hidden');
						textWrap.html(pub.highlight(name,search));
					} else {
						textWrap.html(name);
						$(this).parent().addClass('hidden');
					}
				});

				pub.treeSelectAccordion(search.length);

				$searchWhere.find('.treeSelect-parent-li').each(function (e) {
					var notHiddenLength = $(this).find('.treeSelect-child-li').not('.hidden').length;

					if (notHiddenLength) {
						$(this).removeClass('hidden')
					} else {
						$(this).addClass('hidden');
					}
				});
			});

			$(document).on('click','.treeSelectModalOpen', function (e) {
				e.preventDefault();
				pub.$lastClicked = $(this);
				var treeSelectList =  $(this).prev('.treeSelectList');
				var treeSelectModal = $('#treeSelectModal');
				var checkedValues = treeSelectList.find('input');


				treeSelectModal.find('.treeSelectInput input[type="checkbox"]').each(function () {
					$(this).prop('checked',false);
					$(this).attr('disabled',false);
				});

				checkedValues.each(function(){
					var value = $(this).val();
					treeSelectModal.find('.treeSelectInput input[value="'+value+'"]').prop('checked',true);
				});
				treeSelectModal.find('.treeSelectInput input[type="checkbox"]').eq(1).trigger('change');


				treeSelectModal.modal('show');



			});
			pub.treeSelectOnSubmit();
		},

		treeSelectOnSubmit: function()
		{
			var treeSelectModal = $('#treeSelectModal'),
				template = $('#treeSelect-listView').html();


			treeSelectModal.on('click', '.ok', function (e) {console.log(template);
				e.preventDefault();
				var treeSelectList = pub.$lastClicked.prev('.treeSelectList');
				var inputName = pub.$lastClicked.attr('data-input-name');
				var selectedTree = [];
				var checkedParent = treeSelectModal.find('.hiddenParentCheckbox:checked');


				if(checkedParent.length) {

					checkedParent.each(function () {
						var checkedParentWrap = $(this).closest('.treeSelect-parent-li'),
							parentText = checkedParentWrap.find('.treeSelect-parent-title').text(),
							parentId = $(this).val();

						var child = checkedParentWrap.find('input[type="checkbox"]:checked').not('.hiddenParentCheckbox');
						var childObj = [];
						child.each(function(){
							var childId = $(this).val(),
								childText = $(this).parent().text();
							childObj.push({id: childId,name: childText});
						});

						selectedTree.push({
							parentName:parentText,
							parentId:parentId,
							child: childObj
						})
					});



					for(var i in selectedTree){
						console.log(selectedTree[i].child.map(function(elem){return elem.name;}).join(", "));
					}

					var renderedTemplate = _.template(template,{
						treeSelect: selectedTree,
						inputName: inputName
					});

					//console.log(npm install gulp --global);
					treeSelectList.html(renderedTemplate);
				}

				treeSelectModal.modal('hide');
			});

			pub.onTreeSelectModalOpen();
			pub.treeSelectRemove();
		},

		onTreeSelectModalOpen: function()
		{
			$('#treeSelectModal').on('shown.bs.modal', function(){
				pub.profAreaAccordion(false);

				var treeSelect = $('.treeSelectInput');
				treeSelect.find('.treeSelect-parent-icon .fa').removeClass('fa-minus').addClass('fa-plus');
				treeSelect.find('.treeSelect-child-ul').addClass('hidden');

				var checkedInputWrap = $('.treeSelectInput input[type="checkbox"]:checked').closest('.treeSelect-parent-li');
				checkedInputWrap.find('.treeSelect-parent-icon .fa').removeClass('fa-plus').addClass('fa-minus');
				checkedInputWrap.find('.treeSelect-child-ul').removeClass('hidden');
			});
		},

		treeSelectRemove: function () {
			$(document).on('click','.treeSelect-list-remove',function(e){
				e.preventDefault();
				var self = $(this),
					isParent = self.hasClass('removeParent');
				if(isParent) {
					self.closest('ul').remove()
				} else {
					self.closest('li').remove();
				}

				$('.treeSelectList>ul').each(function () {
					var childLength = $(this).find('ul li').length;
					if(childLength < 1) {
						$(this).remove();
					}
				});


			})
		},


		treeSelectAccordion: function(open)
		{
			var treeSelect = $('.treeSelectInput');
			var title = treeSelect.find('.treeSelect-parent-title'),
				closesLi = title.closest('li'),
				childUl = closesLi.find('.treeSelect-child-ul');

			if(open) {
				childUl.removeClass('hidden');
				closesLi.find('.treeSelect-parent-icon .fa').removeClass('fa-plus').addClass('fa-minus');
			} else {
				childUl.addClass('hidden');
				closesLi.find('.treeSelect-parent-icon .fa').removeClass('fa-minus').addClass('fa-plus');
			}
		},

		profAreaAccordion: function(open)
		{
			var profAreaInput = $('.profAreaInput');
			var title = profAreaInput.find('.profArea-parent-title'),
				closesLi = title.closest('li'),
				childUl = closesLi.find('.profArea-child-ul');

			if(open) {
				childUl.removeClass('hidden');
				closesLi.find('.profArea-parent-icon .fa').removeClass('fa-plus').addClass('fa-minus');
			} else {
				childUl.addClass('hidden');
				closesLi.find('.profArea-parent-icon .fa').removeClass('fa-minus').addClass('fa-plus');
			}
		},

		profAreaSearchFilter: function ()
		{
			var searchFilterInput = $('#searchFilterProfArea input');
			searchFilterInput.on('input', function (e) {

				var search = $(this).val().toLowerCase(),
					searchWhere = $(this).data('list'),
					$searchWhere = $(searchWhere);


					var elementWrap = $searchWhere.find('.profArea-child-li label');
					elementWrap.each(function () {
						var textWrap = $(this).find('.profArea-name');

						var name = textWrap.text().trim();
						if (name.toLowerCase().indexOf(search) !== -1) {
							$(this).parent().removeClass('hidden');
							textWrap.html(pub.highlight(name,search));
						} else {
							textWrap.html(name);
							$(this).parent().addClass('hidden');
						}
					});

				pub.profAreaAccordion(search.length);

					$searchWhere.find('.profArea-parent-li').each(function (e) {
						var notHiddenLength = $(this).find('.profArea-child-li').not('.hidden').length;

						if (notHiddenLength) {
							$(this).removeClass('hidden')
						} else {
							$(this).addClass('hidden');
						}
					});
			})

		},

		profAreaList: function()
		{
			$(document).on('click','.profArea-list-remove',function(e){
				e.preventDefault();
				var self = $(this),
					isParent = self.hasClass('removeParent'),
					profAreaId = self.data('profarea-id');
					self.parent().css({'color': 'red'});

					if(isParent) {
						$('.profAreaInput input[type="checkbox"]').prop('checked', false);
						$('.profAreaInput input[type="checkbox"]:first').trigger('change');
						self.closest('ul').remove();
					}   else {
						$('.profAreaInput input[value="' + profAreaId + '"]').prop('checked', false).trigger('change');
						self.parent().remove();
					}

				if($('.profAreaList ul ul li').length < 1) {
					$('.profAreaList ul').remove()
				}
			})
		},

		onSubmitProfArea: function(){
			var profAreaModal = $('#profAreaModal'),
				template = $('#profArea-listView').html();

			profAreaModal.on('click','.ok', function(e){
				e.preventDefault();

				var checkedParent = profAreaModal.find('.hiddenParentCheckbox:checked'),
					checkedParentWrap = checkedParent.closest('.profArea-parent-li'),
					parentText = checkedParentWrap.find('.profArea-parent-title').text(),
					parentId = checkedParent.val();

				var child = checkedParentWrap.find('input[type="checkbox"]:checked').not('.hiddenParentCheckbox');
					var childObj = [];
					child.each(function(){
						var childId = $(this).val(),
							childText = $(this).parent().text();
						childObj.push({id: childId,name: childText});
					});

				var renderedTemplate = _.template(template,{
					parentId: parentId,
					parentName: parentText,
					childItems: childObj
				});
				$('.profAreaList').html(renderedTemplate);

				profAreaModal.modal('hide');
			})
		},

		onProfAreaModalShown: function()
		{
			$('#profAreaModal').on('shown.bs.modal', function(){
				pub.profAreaAccordion(false);

				var checkedInputWrap = $('.profAreaInput input[type="checkbox"]:checked').closest('.profArea-parent-li');
				checkedInputWrap.find('.profArea-parent-icon .fa').removeClass('fa-plus').addClass('fa-minus');
				checkedInputWrap.find('.profArea-child-ul').removeClass('hidden');
			});
		},

		highlight: function(text,search)
		{
			var start = text.toLowerCase().indexOf(search.toLowerCase());
			if (start != -1) {
				return text.replace( new RegExp( "(" + pub.preg_quote( search ) + ")" , 'gi' ), '<i class="highlight">$1</i>' );
			} else {
				return text;
			}


		},
		preg_quote: function ( str ) {
			return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
		},

		/*END RESUME POSITION*/

		initSelect2: function()
		{
			function e(e, t, n, r) {
				return e % 10 < 5 && e % 10 > 0 && e % 100 < 5 || e % 100 > 20 ? e % 10 > 1 ? n : t : r
			}


			$(document).find('select').select2({
				minimumResultsForSearch: -1,
				language: {
					errorLoading: function () {
						return "Невозможно загрузить результаты"
					}, inputTooLong: function (t) {
						var n = t.input.length - t.maximum, r = "Пожалуйста, введите на " + n + " символ";
						return r += e(n, "", "a", "ов"), r += " меньше", r
					}, inputTooShort: function (t) {
						var n = t.minimum - t.input.length, r = "Пожалуйста, введите еще хотя бы " + n + " символ";
						return r += e(n, "", "a", "ов"), r
					}, loadingMore: function () {
						return "Загрузка данных…"
					}, maximumSelected: function (t) {
						var n = "Вы можете выбрать не более " + t.maximum + " элемент";
						return n += e(t.maximum, "", "a", "ов"), n
					}, noResults: function () {
						return "Совпадений не найдено"
					}, searching: function () {
						return "Поиск…"
					}
				}
			});
		},

		/*START RESUME EDUCATION*/

		universityComplete: function()
		{
			var $input = $('.universityComplete');
			$input.each(function(e){
				$(this).autocomplete({
					source: function( request, response ) {
						$.ajax({
							url: "/ajax/university",
							dataType: "json",
							type : 'GET',
							data: {
								query: request.term
							},
							success: function( data ) {
								response( data );
							}
						});
					},
					minLength: 1,
					select: function( event, ui ) {
						$(this).val( ui.item.name );
						return false;
					}
				})
				.autocomplete( "instance" )._renderItem = function( ul, item ) {
					return $( "<li>" )
						.append(
						'<div class="universityCompleteWrap clearfix"><div class="universityCompleteLeft">' +
						'<div class="universityAcronym">' + item.acronym + '</div>' +
						'</div>' +
						'<div class="universityCompleteRight">' +
						'<div class="universityName">' + item.name + '</div>' +
						'<div class="universitySynonyms">' + item.synonyms + '</div>' +
						'</div></div>')
						.appendTo( ul );
				};
			})
		},

		cloneFormGroup: function()
		{
			var $formGroupBtn = $('.add-form-group');

			$formGroupBtn.on('click', function(e){
				e.preventDefault();
				var self = $(this),
					idFormGroupWrap = self.data('id'),
					$formWrap = $(idFormGroupWrap);
				var $cloneBlock = $formWrap.find('.clone-form-block').eq(0).clone();

				var inputs = $cloneBlock.find(':input');

				inputs.each(function(e){
					var self = $(this),
						name = self.attr('name');

					if(self.is('select')){
						self.removeClass('select2-hidden-accessible');
					}
				});

				$cloneBlock.find('.select2').remove();
				$cloneBlock.find('.form-group').removeClass('has-error');
				$cloneBlock.find('.form-group .help-block').remove();
				$cloneBlock.find(':input').not('[type="checkbox"]').val("").attr('value','');
				$cloneBlock.find('.treeSelectList').html("");
				$cloneBlock.find('.removeDisabled').prop('disabled',false);
				$cloneBlock.find('[type="checkbox"]').removeAttr('checked').prop('checked',false);


				$cloneBlock.find('.remove-first-block-link').removeClass('active_first');

				$formWrap.append(
					$('<div>').append($cloneBlock).html() //Фишка чтобы взять элемент с родителем
				);

				$(document).find(idFormGroupWrap + ' .clone-form-block').each(function(i){
					$(this).find(':input').each(function(){
						var self = $(this),
							name = self.attr('name');
						self.attr('name',name.replace(/([0-9]+)/, i));
					});

					$(this).find('.treeSelectModalOpen').each(function () {
						var self = $(this),
							inputName = self.data('input-name');

						if(inputName != undefined) {
							self.attr('data-input-name',inputName.replace(/([0-9]+)/, i));
						}
					})
				});
				pub.initSelect2();
				$formWrap.find('.remove-first-block-link').not('.active_first').each(function(){$(this).parent().show()});
				pub.universityComplete();
			});

			$(document).on('click', '.remove-first-block-link', function (e) {
				e.preventDefault();
				var self = $(this);
				var block = self.parents('.clone-form-group-wrap');
				if (confirm(self.data('title'))) {
					self.closest('.clone-form-block').remove();
					if(block.length) $("html, body").stop().animate({scrollTop:block.offset().top - 30}, 800, 'swing');
				}else{
					// var self = $(this),
					// 	$formWrap = self.closest('.clone-form-block');
					// var removeBtns = self.closest('.clone-form-group-wrap').find('.remove-first-block-link'),
					// 	idParent = "#" + self.closest('.clone-form-group-wrap').attr('id');

					// var isEmpty = true;
					// $formWrap.find('select,input').each(function () {
					// 	if ($(this).val() != "") {
					// 		isEmpty = false;
					// 	}
					// });
					// //if (isEmpty) {
					// 	//$formWrap.remove();
					// //} else {

				 //   //}

					// $(document).find(idParent + ' .clone-form-block').each(function (i) {
					// 	$(this).find('input,select').each(function () {
					// 		var self = $(this),
					// 			name = self.attr('name');
					// 		self.attr('name', name.replace(/([0-9]+)/, i));
					// 	});
					// });

					// if (removeBtns.length == 2) {
					// 	removeBtns.parent().hide();
					// }
				}


			});

		},

		addLanguage: function()
		{
			$('.add-languages').on('click', function(e){
				e.preventDefault();
				var self = $(this),
					langTemplate = $('#languageTemplate').html(),
					langWrap = $('#languages');

					console.log(langTemplate);

					var langLen = $(document).find('.lang-form-wrap').length;
					langWrap.append(langTemplate.replace(new RegExp("KEY",'g'),langLen));
				pub.initSelect2();
			});

			$(document).on('click','.removeLang', function(e){
				e.preventDefault();
				var self = $(this),
					langWrap = self.closest('.lang-form-wrap');
				console.log('removeLang');
				langWrap.remove();
			});

			$(document).on('change','.languageChange', function(){
				var self = $(this),
					langWrap = self.closest('.lang-form-wrap'),
					degree = langWrap.find('.languagePast'),
					currentID =self.val();
				var isBeforeSelected = false;

					$('.languageChange, .nativeLangId').not(self).each(function(){
						if($(this).val() == currentID) {
							isBeforeSelected = true;
						}
					});
					if(currentID !== '' && !isBeforeSelected) {
						degree.removeAttr('disabled');
					} else {
						degree.attr('disabled','disabled');
					}
			});

			$('.nativeLangId').on('change', function(){
				var currentId = $(this).val();
				$('#languages select[disabled="disabled"]').removeAttr('disabled');
				$('#languages input[value="'+currentId+'"]').parent().find('select').attr('disabled','disabled');

				$('.languageChange').each(function(){
					if($(this).val() == currentId) {
						var self = $(this),
							langWrap = self.closest('.lang-form-wrap'),
							degree = langWrap.find('.languagePast');
							degree.attr('disabled','disabled');
					}
				})
			})
		},

		addCertificate: function()
		{
			//Certificate
			$('.add-certificate').click(function(e){
				$('.certificate-drop').hide();
				$(this).parent('.certificate').find('.certificate-drop').show();
			});
			$('.btn-reset').click(function(e){
				e.preventDefault();
				$(this).parents('.certificate-drop').hide();
				$(this).parents('.certificate-drop :input').val("");
			});

			$('.certificate-form').on('input',':input', function(){

				var self = $(this),
					formWrap = self.closest('.certificate-form'),
					formWrapInputs = formWrap.find(':input');

					var isValidated = {};

					formWrapInputs.each(function(e){
						var input = $(this),
							value = input.val(),
							name = input.attr('name');
							if(name == 'cert_name') {
								isValidated.certName = value.length >= 1;
							}

							if(name == 'cert_end') {
								isValidated.certEnd = !!( value >= 1950 && value <= 2100);
							}

							if(name == 'cert_url') {
								if(value.indexOf('http://') === 0 || value.indexOf('https://') === 0) {
									isValidated.certUrl = true;
								} else {
									isValidated.cerUrl = false;
								}
							}
					});


					if (_.every(isValidated)) {
						formWrap.find('.addCert').removeAttr('disabled');
					} else {
						formWrap.find('.addCert').attr('disabled', 'disabled');
					}

			});






			$(document).on('click','.delete-cert', function(e){
				e.preventDefault();
				var self = $(this),
					certName = self.closest('li').find('a').not('.delete-cert').text().trim(),
					parentUl = self.closest('ul'),
					parentUlUl = parentUl.parent().parent();

				if(confirm('Удалить "' + certName + '"')) {
					if(parentUl.find('li').length > 1) {
						self.closest('li').remove();
					}else {
						parentUlUl.remove();
					}
				}

			});

			function certHtmlObject() {
				var certList = {'other' : [],'microsoft': []};
				var microsoftUl = $('.certificates-view-microsoft>div>ul');
				if(microsoftUl.length) {
					microsoftUl.each(function(){
						var ul = $(this),
							childLi= ul.find('ul li'),
							year = ul.find('.certYear').text().trim();

						childLi.each(function(){
							var link = $(this).find('a');
							certList['microsoft'].push({
								end: year,
								name: link.text().trim(),
								url: link.attr('href')
							})
						});
					});
				}
				var otherUl = $('.certificates-view>div>ul');
				if(otherUl.length) {
					otherUl.each(function(){
						var ul = $(this),
							childLi= ul.find('ul li'),
							year = ul.find('.certYear').text().trim();

						childLi.each(function(){
							var link = $(this).find('a');
							certList['other'].push({
								end: year,
								name: link.text().trim(),
								url: link.attr('href')
							})
						});
					});
				}


				return certList;
			}
			var certList = {'other' : [],'microsoft': []};
			$('.addCert').on('click', function(e){
				e.preventDefault();
				certList = certHtmlObject();
				var self = $(this),
					wrap = self.closest('.certificate-drop'),
					isMicrosoft = self.hasClass('microsoft-add');

				var certName = wrap.find('input[name="cert_name"]').val(),
					certEnd = wrap.find('select[name="cert_end"]').val(),
					certUrl = wrap.find('input[name="cert_url"]').val();

				var cert = {
					name: certName,
					end: certEnd,
					url: certUrl
				};

				if(isMicrosoft) {
					certList['microsoft'].push(cert);
				}else {
					certList['other'].push(cert);
				}


				var grouped = _.groupBy(isMicrosoft ? certList['microsoft'] : certList['other'], function(obj){
					return obj.end;
				});

				var certTemplate = $('#certTemplate').html();
				var certHtml = "";
				var counter = 0;
				_.each(grouped, function(v,index){
					certHtml += "<ul><li><div class='certYear'>" + index + "</div>";
					certHtml += "<ul>";
					_.each(v, function(value){
						certHtml += _.template(certTemplate,{
							name: value.name,
							end: value.end,
							url: value.url,
							key: counter,
							type: isMicrosoft ? 'microsoft' : 'other'
						});
						counter++;
					});
					certHtml += "</ul>";
					certHtml += "</ul>";

				});
				if(isMicrosoft) {
					$('.certificates-view-microsoft').removeClass('hidden');
					$('.certificates-view-microsoft>div').html(certHtml);
				}else {
					$('.certificates-view').removeClass('hidden');
					$('.certificates-view>div').html(certHtml);
				}

				$('.btn-reset').trigger('click');
				wrap.find('input').each(function(){
					$(this).val("");
				})

			});


		},

		initResumeEducation: function()
		{
			pub.universityComplete();
			pub.cloneFormGroup();
			pub.addCertificate();
			pub.addLanguage();
		},
		/*END RESUME EDUCATION*/



		ajaxValidator: function()
		{

			$('form.ajaxFormValidator').on('submit', function(e){
				if(typeof(CKEDITOR) !== 'undefined' && CKEDITOR.instances != undefined) {
					for ( var instance in CKEDITOR.instances ) {
						CKEDITOR.instances[instance].updateElement();
					}
				}

				e.preventDefault();
				var self = $(this),
					action = self.attr('action'),
					formData = new FormData($(this)[0]);


				$.ajax({
					url: action,
					type: 'POST',
					data: formData,
					cache: false,
					contentType: false,
					processData: false,
					beforeSend: function()
					{
						var formGroup = $('form.ajaxFormValidator .form-group');
						formGroup.removeClass('has-error');
						formGroup.removeClass('has-error-input');
						formGroup.find('.help-block').remove();
						$('form.ajaxFormValidator .help-block').remove();

					},
					success: function(data){
						ajaxSuccessAlert(data);
					},
					error: function( xhr,status, response ) {
						var error = jQuery.parseJSON(xhr.responseText);
						$.each(error,function(key,value){
							if(key.match(/\[(\w+)\.(\w+)\]/)) {
								key = key.replace(/\[(\w+)\.(\w+)\]/,'[$1][$2]');
							}
							var input;

							if(key.indexOf('.') == 0) {
								input = $(document).find(key);
								input.addClass('has-error').append('<div class="help-block">'+value[0]+'</div>');
								var inputRed = $(document).find(key+'Red');
								if(inputRed.length) {
									inputRed.addClass('has-error-input');
								}

							} else {
								if($(document).find(':input[name="'+key+'"]').length) {
									input = $(document).find(':input[name="'+key+'"]');
								}else if($(document).find(':input[name="'+key+'[]"]').length) {
									input = $(document).find(':input[name="'+key+'[]"]')
								} else {
									//console.error('notFount:' + key);
								}
								if(input instanceof jQuery && input.attr('data-error-view')) {
									input = $(input.attr('data-error-view'));
									input.addClass('has-error');
									input.html('<div class="help-block">'+value[0]+'</div>');
								} else {
									if(input != undefined) {
										input.parent().addClass('has-error');
										if(input.parent().find('.help-block').length) {
											input.parent().find('.help-block').html(value[0]);
										}else {
											input.parent().append('<div class="help-block">'+value[0]+'</div>');
										}
									}
								}



							}


							/*
							Если нужен tooltip. Но он глючит при копирвание
							input.parent().tooltip('destroy').tooltip({
								title: value[0],
								html:true,
								trigger:'manual'
							}).tooltip('show');*/

						});
					}

				});

				return false;
			});
		},



		initTagAutoComplete: function () {
			var tagsAutoComplete = $('.tagsAutoComplete');

			tagsAutoComplete.autocomplete({
				source: function( request, response ) {
					$.ajax({
						url: "/ajax/skills",
						dataType: "json",
						type : 'GET',
						data: {
							query: request.term
						},
						beforeSend: function () {
						},
						success: function( data ) {
							response( data );
						}
					});
				},
				minLength: 1,
				autoFocus: true,
				select: function( event, ui ) {
					pub.tagAutoCompletePast(ui.item);
					return false;
				}
			}).autocomplete( "instance" )._renderItem = function( ul, item ) {
				return $( "<li>" )
					.append(item.name).appendTo( ul );
			};


			tagsAutoComplete.on('keypress', function(e){
				if(e.keyCode == 13){
					e.preventDefault();
					var value = $(this).val();

					pub.tagAutoCompletePast({
						name: $(this).val()
					});
					$(this).val("");
				}
			});


			pub.tagAutoCompleteRemove();

		},

		tagAutoCompletePast: function (tag) {
			var tagsAutoCompleteHtml = $('#tagsAutoCompleteHtml').html();
			var tagsAutoCompletePast = $('.tagsAutoCompletePast');

			var tagIsset = false;

			tagsAutoCompletePast.find('input').each(function(){
				var value = $(this).val().trim();
				if(tag.name.toLowerCase() == value.toLowerCase()) {
					tagIsset = true;
				}

			});

			if(!tagIsset) {
				var tagHtml = _.template(tagsAutoCompleteHtml,{
					tagName: tag.name
				});
				tagsAutoCompletePast.append(tagHtml);
			}

			tagsAutoCompletePast.removeClass('hidden');

		},

		tagAutoCompleteRemove: function () {
			$(document).on('click','.tagsAutoCompleteRemove', function (e) {
				e.preventDefault();

				$(this).closest('.tagsAutoCompleteItem').remove();
			})
		},


		portfolioImageUpload: function () {
			$.ajaxSetup({
				headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() }
			});
			$('.portfolioImageBtn').on('click', function (e) {
				e.preventDefault();
				var uploadBtn = $(this),
					uploadBtnText = uploadBtn.text();

				var folioTemplate = $('#folioTemplate').html();
				var folioImg = $('[name="portfolio[image]"]'),
					folioDesc = $('[name="portfolio[desc]"]'),
					folioId = $('[name="portfolio[id]"]');


				var imgData = folioImg.prop('files')[0];
				var formData = new FormData();

				formData.append('image', imgData);
				formData.append('description', folioDesc.val());
				formData.append('id', folioId.val());
				$.ajax({
					type: "POST",
					data: formData,
					url: '/applicant/resume/edit/experience/upload-folio',
					cache: false,
					contentType: false,
					processData: false,
					beforeSend: showRequest,
					success: showResponse,
					dataType: 'json'
				});
				function showRequest(formData, jqForm, options) {
					$('.imageInput').html("");
					uploadBtn.attr('disabled', 'disabled');
					uploadBtn.html(uploadBtnText + " " + pub.spinner);
					return true;
				}

				function showResponse(response, statusText, xhr, $form) {
					if (response.success == false) {
						var arr = response.errors;
						$('.imageInput').html('<div class="help-block">'+arr['image'][0]+'</div>');

					} else {
						var htmlToAppend = _.template(folioTemplate, response.image);
						$('.portfolioImagePast').append(htmlToAppend).removeClass('hidden');
						$('[name="portfolio[image]"]').val("").trigger('change');
						$('[name="portfolio[desc]"]').val("");
					}

					uploadBtn.removeAttr('disabled');
					uploadBtn.html(uploadBtnText);
				}

			});





			$(document).on('click','.folioEdit', function(e){
				e.preventDefault();
				var self = $(this);
				var folioModal = $('#folioModal');
				var id = self.data('image-id');
				$.ajax({
					url:'/applicant/resume/edit/experience/upload-folio/edit',
					data: {'id':id,'type':'get'},
					dataType: 'json',
					type:'post',
					success: function(data){
						if(data.name !== undefined){
							var img = $('<img />',{
								src: '/uploads/portfolio_image/'+data.name
							});
							folioModal.find('.folioModal-img').html(img);
							folioModal.find('[name="folio[description]"]').val(data.description);
							folioModal.find('[name="folio[id]"]').val(data.id);
							folioModal.modal('show');
						} else {
							console.error(pub.errorMessage);
							alert(pub.errorMessage);
						}
					}
				});
			});
			$('#folioModal .ok').on('click',function(e){
				e.preventDefault();
				var folioModal = $('#folioModal'),
					description = folioModal.find('[name="folio[description]"]').val(),
					id = folioModal.find('[name="folio[id]"]').val();

				$.ajax({
					url:'/applicant/resume/edit/experience/upload-folio/edit',
					data: {'id':id,'type':'update',description:description},
					dataType: 'json',
					type:'post',
					success: function(data){
						if(data.success == true){

							folioModal.modal('hide');
						} else {
							alert(pub.errorMessage);
						}
					}
				});
			});
			$('#folioModal .remove').on('click',function(e){
				e.preventDefault();
				var folioModal = $('#folioModal'),
					id = folioModal.find('[name="folio[id]"]').val();

				$.ajax({
					url:'/applicant/resume/edit/experience/upload-folio/edit',
					data: {'id':id,'type':'delete'},
					dataType: 'json',
					type:'post',
					success: function(data){
						if(data.success == true){
							$('.folio-img-' + id).remove();
							folioModal.modal('hide');
						} else {
							alert(pub.errorMessage);
						}
					}
				});
			});


		},


		/*experience*/
		experienceTillNow: function()
		{
			$(document).on('change','.tillNow', function (e) {
				var value = $(this).val(),
					isChecked = $(this).is(':checked');
				var endDate = $(this).closest('.experience-block').find('.endDate');

				if(isChecked) {
					endDate.prop('disabled',true);
				}else {
					endDate.prop('disabled',false);
				}
			});
			$('.tillNow').trigger('change');
		},

		/*experience*/

		/*settings*/


		checkboxFreeze: function () {
			var freezeCheckbox = $('[name="freeze"]');

			if(freezeCheckbox.length) {
				freezeCheckbox.bootstrapSwitch({
					onText: '=',
					offText: '=',
					handleWidth: 50
				});
			}


			freezeCheckbox.on('switchChange.bootstrapSwitch', function(event, state) {

				$.ajax({
					type: 'POST',
					url: '/applicant/settings/store/freeze',
					data: {freeze: +state},
					success: function (data) {
						console.log(data) ;
						if(data.success != undefined && data.success == true && data.redirectUrl != undefined) {
							document.location.reload();
						}
					}
				})

			});

			$('.freezeSwitcher').on('click', function (e) {
				e.preventDefault();

				if($(this).hasClass('freezeOn')) {
					$('[name="freeze"]').bootstrapSwitch('state', true, false);
				} else {
					$('[name="freeze"]').bootstrapSwitch('state', false, false);
				}
			});
		},

		initSettings: function () {
			this.checkboxFreeze();
		},
		/*settings*/

		/*Employer register*/
		employerRegisterForm: function () {

			var name_class = 'test';
			var validated = false;
			var buton_submit = false;
			var my_form = $('#registerEmployer');
			var on_start = true;

			my_form.on('submit', function(){
				validate();
				return false;
			});

			my_form.find(':input').on('change', function(){
				validate('/employer/auth/validate');
				return false;
			});

			var idFields = {
				'company.name' : 'companyName',
				'company.itn' : 'companyItn',
				'company.itn_head' : 'companyItnHead',
				'company.full_name_head' : 'companyFullNameHead',
				'company.form' : 'companyForm',
				'company.site' : 'companySite',
				'company.area_id' : 'companyAreaId',
				'user.surname' : 'userSurname',
				'user.name' : 'userName',
				'user.email' : 'userEmail',
				'user.password' : 'userPass',
				'phone.prefix' : 'phonePrefix',
				'phone.code' : 'phoneCode',
				'phone.number' : 'phoneNumber'
			};

			function validate(ajaxUrl){

				var url = ajaxUrl || my_form.attr('action');

				$.ajax({
					url: url,
					type: 'post',
					data: my_form.serialize(),
					beforeSend: function () {
						my_form.find('.form-error').removeClass('form-error');
					},
					success: function(data){
						if(data.success == true) {
							$('#requiredMessage').addClass('hidden');
							$('#requiredMessage .requiredMessageFields').html("");
						}
						if(data.success == true && data.redirectUrl !== undefined) {
							window.location.href = data.redirectUrl;
						}
					},
					error: function(jqXhr){

						var errors = jqXhr.responseJSON;

						var campos_error = [];

						$('#requiredMessage .requiredMessageFields').html("");
						$.each(errors.errors,function(key, data){
							var input = $('#'+idFields[key]),
								inputTitle = input.data('title');
							input.addClass('form-error');
							campos_error.push(key);

							if(inputTitle !== undefined){
								var ReqField = $('<a></a><br>').text(inputTitle + ' (' + data[0] + ')').attr('href','#'+idFields[key]);
								$('#requiredMessage .requiredMessageFields').append(ReqField).append("  ");
								$('#requiredMessage').removeClass('hidden');
							}

						});
						validated = false;
						buton_submit = false;
					}
				});
				return false;
			}
		},

		/*Employer register*/
		employerConfirm: function () {

			var validated = false;
			var buton_submit = false;
			var my_form = $('#confirmEmployer');
			var on_start = true;

			my_form.on('submit', function(){
				validate();
				return false;
			});

			my_form.find(':input').on('change', function(){
				validate('/employer/auth/validate');
				return false;
			});

			var idFields = {
				'user.email' : 'userEmail',
			};

			function validate(ajaxUrl){

				var url = ajaxUrl || my_form.attr('action');

				$.ajax({
					url: url,
					type: 'post',
					data: my_form.serialize(),
					beforeSend: function () {
						my_form.find('.form-error').removeClass('form-error');
					},
					success: function(data){
						if(data.success == true) {
							$('#requiredMessage').addClass('hidden');
							$('#requiredMessage .requiredMessageFields').html("");
						}
						if(data.success == true && data.redirectUrl !== undefined) {
							window.location.href = data.redirectUrl;
						}
					},
					error: function(jqXhr){

						var errors = jqXhr.responseJSON;

						var campos_error = [];

						$('#requiredMessage .requiredMessageFields').html("");
						$.each(errors.errors,function(key, data){
							var input = $('#'+idFields[key]),
								inputTitle = input.data('title');
							input.addClass('form-error');
							campos_error.push(key);


							var ReqField = $('<a></a>')
								.text(inputTitle)
								.attr('href','#'+idFields[key]);
							$('#requiredMessage .requiredMessageFields').append(ReqField).append("  ");
							$('#requiredMessage').removeClass('hidden');

						});
						validated = false;
						buton_submit = false;
					}
				});
				return false;
			}
		},


		emailVars: function(){
			$('.emailVars').on('click', function(e){
				e.preventDefault();
				var self = $(this),
					varToPas = self.data('name'),
					textArea = self.closest('.panel-body').find('textarea');

				//console.log(varToPas);
				//textArea.val(textBefore + '[' + varToPas + '] ' + textAfter);
				pub.insertAtCaret(textArea,'['+varToPas+'] ');
			});
		} ,

		insertAtCaret: function (el,newText) {
			var start = el.prop("selectionStart");
			var end = el.prop("selectionEnd");
			var text = el.val();
			var before = text.substring(0, start);
			var after  = text.substring(end, text.length);
			el.val(before + newText + after);
			el[0].selectionStart = el[0].selectionEnd = start + newText.length;
			el.focus();
		},

		companyInfoForm: function () {
			$('.company-info-form :input').not('[type="file"],[type="hidden"]').on('change', function(){
				var self =  $(this),
					v = self.val(),
					n = self.attr('name');

					if(v == '') {
						self.closest('.company-input').hide();
						self.closest('.form-closest').find('.showBlockBtn').show();
					}

				var formData = new FormData();
				formData.append(n,v);
				saveCompanyForm(formData);
			});

			$('.okCompanyActivity').on('click', function (e) {
				setTimeout(function(){
					var formData = new FormData();

					$('.company-info-form [name="company_activity[]"]').each(function () {
						console.log($(this).attr('name'), $(this).val());
						formData.append($(this).attr('name'),$(this).val());
					});

					saveCompanyForm(formData);
				},1000);
			});


			$('.uploadLogo').on('click', function(e){
				e.preventDefault();
				var logoInput =$('[name="logo"]');
				logoInput.click();

			});

			$('[name="logo"]').on('change', function () {
				var logoInput = $(this);
				var formData = new FormData();
				var file = logoInput[0].files[0];
				formData.append('logo',file,file.name);

				saveCompanyForm(formData);
			});

			$('.deleteLogo').on('click', function (e) {
				e.preventDefault();
				$.post('/employer/company/delete-logo',{id:$(this).data('id')},function(){
					document.location.href = '/employer/company';
				})
			});


			function saveCompanyForm(formData)
			{
				//var form = $('form.company-info-form');

				$.ajax({
					'url':'/employer/company/store',
					'type':'POST',
					'data': formData,
					success: function(json){
						if(json.success) {
							document.location.href = json.redirectUrl;
						}
					},
					cache: false,
					contentType: false,
					processData: false

				})
			}
		},

		/*Employer register*/



		/*Show Block Btn*/
		showBlockBtn: function () {
			$('.showBlockBtn').on('click', function (e) {
				e.preventDefault();
				var self = $(this),
					showBlock = self.attr('data-show-block'),
					hideSelf = self.attr('data-hide-self') || '0',
					clearInput = self.attr('data-clear-input') || '0',
					$showBlock = $(showBlock);
					console.log(hideSelf);
					if(hideSelf == '1'){
						self.hide();
					}

					if(clearInput == '1') {
						$showBlock.find(':input').val("");
					}

					if($showBlock.css('display') == 'none') {
						$showBlock.show();
					}else {
						$showBlock.hide();
					}

			})
		},
		/*Show Block Btn*/

		colorPicker: function () {
			var picker = $('.emp-colorpicker');
			picker.simplecolorpicker();

			var color = '';
			picker.on('change', function(e){
				color = $(this).val();
				colorChange(color)
			});


			$('.colorPicker-ok').on('click', function (e) {
				e.preventDefault();
				var formData = new FormData();
				var color = picker.val();
				color = color.replace('#','');
				formData.append('color', color);
				$.ajax({
					type: 'POST',
					url:'/employer/company/store',
					data:formData,
					success: function(json){
						if(json.success) {
							document.location.href = '/employer/company'
						}
					},

					cache: false,
					contentType: false,
					processData: false
				})
			})

			function colorChange(hex){
				if(hex == 'default') {
					$('.colorPicker-bgChange').css({'background-color':''});
					$('.colorPicker-brChange').css({'border-color':''});
				}else {
					$('.colorPicker-bgChange').css({'background-color':hex})
					$('.colorPicker-brChange').css({'border-color':hex})
				}
			}

		},

		uploadCompanyContentImage: function()
		{
			$(document).on('click','.companyPageImage',function(e){
				e.preventDefault();
				console.log('clicked');
				var self = $(this),
					fileInput = $('[name="image_upload"]'),
					imageInput = $('[name="image_id"]');


					fileInput.click();
					fileInput.off('change');
					fileInput.on('change', function () {
						var logoInput = $(this);
						var formData = new FormData();
						var file = logoInput[0].files[0];
						formData.append('image_upload',file,file.name);
						saveCompanyForm(formData);
					});
			});

			$(document).on('click','.deleteImage',function(e){
				e.preventDefault();
				var self = $(this),
					id = self.data('id'),
					type = self.data('type');

				$.ajax({
					'url':'/employer/company/delete-pages-image',
					'type':'POST',
					'data': {id:id,type:type},
					success: function(json){
						if(json.success){
							$('#image-append').html("");
							$('#image-append-before').show();
						}
					},
					cache: false
				});


			});

			var html = $('#imageUploaded').html();

			function saveCompanyForm(formData)
			{
				$.ajax({
					'url':'/employer/company/store',
					'type':'POST',
					'data': formData,
					success: function(json){
						if(json.success){
							var htmlToAppend = _.template(html,json.image);
							$('#image-append').html(htmlToAppend);
							var imageInput = $('[name="image_id"]'),
								fileInput = $('[name="image_upload"]');
							imageInput.val(json.image.id);
							fileInput.val("");
							$('#image-append-before').hide();
						}
					},
					cache: false,
					contentType: false,
					processData: false

				})
			}
		},

		advancedSearch: function() {
			$('#advancedSearch').on('change', function(e){
				var self = $(this),
					value = self.val(),
					type = self.data('type'),
					mainSearch  = $('#mainSearch'),
					advancedLink = $('.advancedSearchLink');
					if(value == 'resume') {
						mainSearch.attr('action','/'+type+'/search/resume');
						advancedLink.attr('href','/'+type+'/search/resume/advanced')
					}else {
						mainSearch.attr('action','/'+type+'/search/vacancy');
						advancedLink.attr('href','/'+type+'/search/vacancy/advanced')
					}
			});

			$('#mainSearch, .advancedSearchForm').on('submit', function (e) {
				var q = $(this).find('[name="q"]').val();
				if(q.length >= 3) {
					return true;
				} else {
					alert('Должно быть не менее 3 символов в поле «Ключевые слова»');
					$(this).find(':input').attr('disabled',false);
					return false;
				}
			})
		},
		currentTime: function()
		{
			if($('.currentTime').length) {
				setInterval(function(){
						var currentTime = new Date();
						var hours = currentTime.getHours();
						var minutes = currentTime.getMinutes();
						if(hours < 10) {
							hours = "0" + hours;
						}
						if (minutes < 10) {
							minutes = "0" + minutes;
						}
						$('.currentTime').html(hours + ":" + minutes);
					},
					1000);
			}



			var timer = $('.timer');
			if(timer.length){
				var timeData = timer.data('time').split(':');

				var hour = parseInt(timeData[0]),
					minute = parseInt(timeData[1]),
					second = parseInt(timeData[2]);

				setInterval(function(){
					if(second == 59) {
						second = 0;
						minute++;
					} else {
						second++;
					}
					if(minute == 59) {
						minute = 0;
						hour++;
					}
					var pastMinutes = minute;
					if (pastMinutes < 10) {
						pastMinutes = "0" + pastMinutes;
					}
					var pastHours = hour;
					if (pastHours  < 10) {
						pastHours  = "0" + pastHours;
					}
					timer.html(pastHours + ":" + pastMinutes);
				},1000)
			}
		},
		minHeightWrapper: function()
		{
			var wHeight = $(window).height();
			$('.wrapper').css({'min-width':wHeight+'px'});
		},

		stat: function(){

			//Datepicker
			$.datepicker.setDefaults(
				$.extend($.datepicker.regional["ru"]));
			//$('.datepicker');
			var pickerFrom = $('#dateFrom'),
				pickerTo = $('#dateTo');
			pickerFrom.datepicker({
				inline: true,
				dayName: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
				dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
				monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
				monthNamesShort: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
				dateFormat: 'mm.dd.yy',
				firstDay: 1,
				onSelect: function(selected,e){
					setFormFrom(selected);
				}
			});

			pickerTo.datepicker({
				inline: true,
				dayName: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
				dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
				monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
				monthNamesShort: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
				dateFormat: 'mm.dd.yy',
				firstDay: 1,
				onSelect: function(selected,e){
					setFormTo(selected);
				}
			});

			$('.datepickerChanger span').on('click', function(){
				var self = $(this),
					dateFrom = self.data('from'),
					dateTo = self.data('to');
				setFormFrom(dateFrom);
				setFormTo(dateTo);
				pickerFrom.datepicker("setDate", new Date(dateFrom) );
				pickerTo.datepicker("setDate", new Date(dateTo) );
			});

			function setFormTo(value){
				$('#formTo').val(value);
			}
			function setFormFrom(value){
				$('#formFrom').val(value);
			}
		},

		resumeIsTemplate: function()
		{
			$('[name="resume_is_template"]').on('change', function(e){
				console.log('isChanged');
			})
		},

		aplicantSteps: function()
		{
			$('.applicantSteps').on('change', function(){
				var self = $(this),
					val = self.val();
				self.prop('disabled',true);

				$.ajax({
					type:'POST',
					url:'/applicant/profile/store/steps',
					data:{stepId:val},
					success: function(){
						console.log('Success');
					}
				})
			});
		},

		popupimg: function(){
			$('.popupimg').on('click', function(e){
				e.preventDefault();
				var description = $(this).data('description'),
					imgUrl = $(this).data('img-url');
					var modal = $('#popupimgmodal');

				var imgDiv = modal.find('.folioModal-img').html(
					$('<img>').attr('src',imgUrl).attr('class','img-responsive inline')
				);
				var descDiv = modal.find('.folioModal-desc').html(description);

				modal.modal('show');

			});
		},

		publicationResume: function () {
			$('#publicationResume').on('click', function (e) {
				e.preventDefault();
				var id = $(this).data('resume-id');

				alert(id);

			})
		},

		deleteResume: function() {
			$('.deleteResume').on('click', function(e){
				e.preventDefault();

				if(confirm('Ты действительно хочешь удалить резюме?')) {
					window.location.href = $(this).attr('href');
				}
			})
		},
		onHoverOPen: function(){
			$('.home .private-office-settings').mouseenter(function(e){
				$(this).addClass('open-drop');
			})
			if($('.home .private-office-settings').length) {
				$(document).click(function (e)
				{
					var container = $(".private-office-drop");

					if (!container.is(e.target) // if the target of the click isn't the container...
						&& container.has(e.target).length === 0) // ... nor a descendant of the container
					{
						$('.home .private-office-settings').removeClass('open-drop')
					}
				});
			}
		},

		uploadStepsPic: function() {
			$.ajaxSetup({
				headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() }
			});
			$('.btn-uploadImage-step').on('click', function (e) {
				e.preventDefault();

				var uploadBtn = $(this),
					parentRow = uploadBtn.closest('.step-upload-image-row'),
					uploadBtnText = uploadBtn.text(),
					stepId = parentRow.data('step-id');

				var folioImg = $('#btn-uploadImage-image-' + stepId);

				var imgData = folioImg.prop('files')[0];
				var formData = new FormData();
				var userPhotoTemplate = $('#userPhotoTemplate').html();
				formData.append('image', imgData);
				formData.append('step_id', stepId);
				$.ajax({
					type: "POST",
					data: formData,
					url: '/applicant/profile/store/steps-pic', //FormUrl
					cache: false,
					contentType: false,
					processData: false,
					beforeSend: showRequest,
					success: showResponse,
					dataType: 'json'
				});

				var stepImageTemplate = $('#stepsImageTemplate').html();

				function showRequest(formData, jqForm, options) {
					uploadBtn.attr('disabled', 'disabled');
					uploadBtn.html(uploadBtnText + " " + pub.spinner);
					return true;
				}
				function showResponse(response, statusText, xhr, $form) {
					if (response.success == false) {
						alert(arr['image'][0]);
					} else {
						// alert(response.image);
						parentRow.find('.applicantSteps').prop('checked',true).prop('disabled',true);
						// parentRow.find('.applicantSteps').trigger('click');
						parentRow.find('.step-image-past').html(_.template(stepImageTemplate,{url:response.image.thumb, full: response.image.url}))
					}
					folioImg.val("").trigger('change');
					uploadBtn.removeAttr('disabled');
					uploadBtn.html(uploadBtnText);
				}

			});

			$(document).on('click','.stepImageModal', function(e){
				var self = $(this),
					fullUrl = self.data('full-url');

				var modal = $('#stepsModal'),
					imageWrap = modal.find('.step-img');

					imageWrap.html('<img src="'+fullUrl+'" class="image-responsive">');
				modal.modal('show');
				// alert(fullUrl)
			})
		},

		booking: function() {
			var bookCalendar = $('#booking-calendar');
			var book_date = bookCalendar.data('book-date');
			var beforeShowDay = function (date) {
				return [true,''];
			};

			if(book_date !== undefined && book_date.length) {
				beforeShowDay = function(date) {
					var dat = $.datepicker.formatDate("dd.mm.yy", date);
					var r = [true,''];
					if(dat == book_date) {
						r = [true, 'is_booked'];
					}
					return r;
				}
			}

			bookCalendar.datepicker({
				inline: true,
				dayName: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
				dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
				monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
				monthNamesShort: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
				dateFormat: 'mm.dd.yy',
				// firstDay: 1,
				minDate: 'today',
				beforeShowDay: beforeShowDay
			});

			var bookingModal = $('#bookingModal');

			$('#booking-btn').on('click', function(e){
				e.preventDefault();
				var calendarDate =  bookCalendar.datepicker('getDate');
				var strDateTime =  calendarDate.getDate() + "." + (calendarDate.getMonth()+1) + "." + calendarDate.getFullYear();
				$('.booking-is-ok').show();
				$('.booking-is-not-ok').hide();

				$.ajax({
					url: '/applicant/booking/get-data',
					data: {date: strDateTime},
					type: 'POST',
					success: function(data){
						// var json = JSON.parse(data);
						if(data.success == true) {
							if(data.total > 0) {
								$.each(data.places, function(i,v) {
									if(v > 0) {
										$('[data-book-time="'+i+'"] .bookCount').text(v);
									} else {
										$('[data-book-time="'+i+'"] input').prop('disabled',true);
									}
								});
							} else {
								$('.booking-is-ok').hide();
								$('.booking-is-not-ok').show();
							}

							bookingModal.modal('show');
						} else {
							// if(data.payed == false) {
							//     alert($('#not_payed_text').text());
							// } else {
								if(data.is_change == true) {
									if(data.total > 0) {
										$.each(data.places, function(i,v) {
											if(v > 0) {
												$('[data-book-time="'+i+'"] .bookCount').text(v);
											} else {
												$('[data-book-time="'+i+'"] input').prop('disabled',true);
											}
										});
									} else {
										$('.booking-is-ok').hide();
										$('.booking-is-not-ok').show();
									}

									bookingModal.modal('show');
								} else {
									alert('Ты не можешь изменить дату бронирования на дату раньше чем за три дня до текущей брони.');

								}
							// }
						}


					}
				})

			})

			$('#booking-btn-confirm').on('click', function(e){
				e.preventDefault();

				var calendarDate =  bookCalendar.datepicker('getDate');
				var strDateTime =  calendarDate.getDate() + "." + (calendarDate.getMonth()+1) + "." + calendarDate.getFullYear();
				var time = $('input[name="book_time"]:checked','#bookingModalForm').val();
				$.ajax({
					url: '/applicant/booking/store',
					data: {date: strDateTime, time: time},
					type: 'POST',
					success: function(data){
						if(data.success) {
							window.location.reload(true);
						} else {
							alert(data.message);
						}
					}
				})

			})
		},

		initDocumentReady: function()
		{
			$(document).ready(function(){
				$('.clearEmptyFields').submit(function() {
					$(':input', this).each(function() {
						this.disabled = !($(this).val());
					});
				});
				pub.deleteResume();

				pub.onHoverOPen();
				pub.popupimg();
				pub.aplicantSteps();
				pub.resumeIsTemplate();
				pub.stat();
				pub.ajaxValidator();

				pub.treeSelectInput();
				pub.treeSelectSearch();

				pub.portfolioImageUpload();


				pub.initTagAutoComplete();

				pub.showRow();
				pub.addSocial();
				pub.socialInputChange();
				pub.preferredContact();
				pub.uploadPhoto();

				pub.relocationRadio();
				pub.citizenRadio();
				pub.selectTool();

				pub.onChangeSpecializationArea();
				pub.profAreaSelect();
				pub.profAreaSearchFilter();
				pub.onSubmitProfArea();
				pub.profAreaList();
				pub.onProfAreaModalShown();
				pub.onCareerChange();
				pub.autocompletePositionTitle();


				pub.initResumeEducation();

				pub.experienceTillNow();

				pub.initSettings();

				pub.employerRegisterForm();
				pub.employerConfirm();
				pub.companyInfoForm();
				pub.emailVars();

				pub.showBlockBtn();
				pub.colorPicker();

				pub.uploadCompanyContentImage();

				pub.advancedSearch();
				pub.currentTime();
				pub.minHeightWrapper();
				pub.publicationResume();

				pub.uploadStepsPic();
				pub.booking();



			});
		},
		init: function(){
			this.initDocumentReady();
		}
	};

	return pub;

	function ajaxSuccessAlert(data)
	{
		if(data.success != undefined && data.success == true && data.redirectUrl != undefined) {
			document.location.href = data.redirectUrl;
		}

		if(data.alert !== undefined) {
			var type = data.alert.type,
				selector = data.alert.selector,
				message = data.alert.message;

			var html = _.template('<div class="alert alert-<%- type %> alert-dismissible fade in" role="alert"> <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button> <%- message%></div>',{
				type: type,
				message: message
			});

			$(selector).html(html);

			setTimeout(function(){
				$(document).find('.alert').alert('close');
			}, pub.alertMessageCloseInterval);
		}
	}



})(jQuery);

mamagogo.init();


/*
 * Very simple jQuery Color Picker
 * https://github.com/tkrotoff/jquery-simplecolorpicker
 *
 * Copyright (C) 2012-2013 Tanguy Krotoff <tkrotoff@gmail.com>
 *
 * Licensed under the MIT license
 */


(function($) {
	'use strict';

	/**
	 * Constructor.
	 */
	var SimpleColorPicker = function(select, options) {
		this.init('simplecolorpicker', select, options);
	};


	function hover_link($link,$div){
		//jQuery($link).each(function(index, el) {
			if(!jQuery($div).hasClass('active')){
				jQuery($div).addClass('active');
			}else{
				jQuery($div).removeClass('active');
			}
		//});
	}
	$('.link_to_popap').on('click', function(event) {
		event.preventDefault();
	});
	$('.link_to_popap,.resume_popap').stop().hover(
		function(){
			var link_to_popap = $(this).hasClass('link_to_popap') ? this : $(this).prev('.link_to_popap')[0];
			var resume_popap = $(this).hasClass('resume_popap') ? this : $(this).next('.resume_popap')[0];
			hover_link(link_to_popap,resume_popap);
		},
		function(){
			var link_to_popap = $(this).hasClass('link_to_popap') ? this : $(this).prev('.link_to_popap')[0];
			var resume_popap = $(this).hasClass('resume_popap') ? this : $(this).next('.resume_popap')[0];
			setTimeout(function(){
				hover_link(link_to_popap,resume_popap);
			},200);
		}
	);



	/**
	 * SimpleColorPicker class.
	 */
	SimpleColorPicker.prototype = {
		constructor: SimpleColorPicker,

		init: function(type, select, options) {
			var self = this;

			self.type = type;

			self.$select = $(select);
			self.$select.hide();

			self.options = $.extend({}, $.fn.simplecolorpicker.defaults, options);

			self.$colorList = null;

			if (self.options.picker === true) {
				var selectText = self.$select.find('> option:selected').text();
				self.$icon = $('<span class="simplecolorpicker icon"'
					+ ' title="' + selectText + '"'
					+ ' style="background-color: ' + self.$select.val() + ';"'
					+ ' role="button" tabindex="0">'
					+ '</span>').insertAfter(self.$select);
				self.$icon.on('click.' + self.type, $.proxy(self.showPicker, self));

				self.$picker = $('<span class="simplecolorpicker picker ' + self.options.theme + '"></span>').appendTo(document.body);
				self.$colorList = self.$picker;

				// Hide picker when clicking outside
				$(document).on('mousedown.' + self.type, $.proxy(self.hidePicker, self));
				self.$picker.on('mousedown.' + self.type, $.proxy(self.mousedown, self));
			} else {
				self.$inline = $('<span class="simplecolorpicker inline ' + self.options.theme + '"></span>').insertAfter(self.$select);
				self.$colorList = self.$inline;
			}

			// Build the list of colors
			// <span class="color selected" title="Green" style="background-color: #7bd148;" role="button"></span>
			self.$select.find('> option').each(function() {
				var $option = $(this);
				var color = $option.val();

				var isSelected = $option.is(':selected');
				var isDisabled = $option.is(':disabled');

				var selected = '';
				if (isSelected === true) {
					selected = ' data-selected';
				}

				var disabled = '';
				if (isDisabled === true) {
					disabled = ' data-disabled';
				}

				var title = '';
				if (isDisabled === false) {
					title = ' title="' + $option.text() + '"';
				}

				var role = '';
				if (isDisabled === false) {
					role = ' role="button" tabindex="0"';
				}

				var $colorSpan = $('<span class="color"'
					+ title
					+ ' style="background-color: ' + color + ';"'
					+ ' data-color="' + color + '"'
					+ selected
					+ disabled
					+ role + '>'
					+ '</span>');

				self.$colorList.append($colorSpan);
				$colorSpan.on('click.' + self.type, $.proxy(self.colorSpanClicked, self));

				var $next = $option.next();
				if ($next.is('optgroup') === true) {
					// Vertical break, like hr
					self.$colorList.append('<span class="vr"></span>');
				}
			});
		},

		/**
		 * Changes the selected color.
		 *
		 * @param color the hexadecimal color to select, ex: '#fbd75b'
		 */
		selectColor: function(color) {
			var self = this;

			var $colorSpan = self.$colorList.find('> span.color').filter(function() {
				return $(this).data('color').toLowerCase() === color.toLowerCase();
			});

			if ($colorSpan.length > 0) {
				self.selectColorSpan($colorSpan);
			} else {
				console.error("The given color '" + color + "' could not be found");
			}
		},

		showPicker: function() {
			var pos = this.$icon.offset();
			this.$picker.css({
				// Remove some pixels to align the picker icon with the icons inside the dropdown
				left: pos.left - 6,
				top: pos.top + this.$icon.outerHeight()
			});

			this.$picker.show(this.options.pickerDelay);
		},

		hidePicker: function() {
			this.$picker.hide(this.options.pickerDelay);
		},

		/**
		 * Selects the given span inside $colorList.
		 *
		 * The given span becomes the selected one.
		 * It also changes the HTML select value, this will emit the 'change' event.
		 */
		selectColorSpan: function($colorSpan) {
			var color = $colorSpan.data('color');
			var title = $colorSpan.prop('title');

			// Mark this span as the selected one
			$colorSpan.siblings().removeAttr('data-selected');
			$colorSpan.attr('data-selected', '');

			if (this.options.picker === true) {
				this.$icon.css('background-color', color);
				this.$icon.prop('title', title);
				this.hidePicker();
			}

			// Change HTML select value
			this.$select.val(color);
		},

		/**
		 * The user clicked on a color inside $colorList.
		 */
		colorSpanClicked: function(e) {
			// When a color is clicked, make it the new selected one (unless disabled)
			if ($(e.target).is('[data-disabled]') === false) {
				this.selectColorSpan($(e.target));
				this.$select.trigger('change');
			}
		},

		/**
		 * Prevents the mousedown event from "eating" the click event.
		 */
		mousedown: function(e) {
			e.stopPropagation();
			e.preventDefault();
		},

		destroy: function() {
			if (this.options.picker === true) {
				this.$icon.off('.' + this.type);
				this.$icon.remove();
				$(document).off('.' + this.type);
			}

			this.$colorList.off('.' + this.type);
			this.$colorList.remove();

			this.$select.removeData(this.type);
			this.$select.show();
		}
	};

	/**
	 * Plugin definition.
	 * How to use: $('#id').simplecolorpicker()
	 */
	$.fn.simplecolorpicker = function(option) {
		var args = $.makeArray(arguments);
		args.shift();

		// For HTML element passed to the plugin
		return this.each(function() {
			var $this = $(this),
				data = $this.data('simplecolorpicker'),
				options = typeof option === 'object' && option;
			if (data === undefined) {
				$this.data('simplecolorpicker', (data = new SimpleColorPicker(this, options)));
			}
			if (typeof option === 'string') {
				data[option].apply(data, args);
			}
		});
	};

	/**
	 * Default options.
	 */
	$.fn.simplecolorpicker.defaults = {
		// No theme by default
		theme: '',

		// Show the picker or make it inline
		picker: false,

		// Animation delay in milliseconds
		pickerDelay: 0
	};

})(jQuery);
